import React from 'react';
import { MapPin, Building2, Car, Users, Heart, Accessibility } from 'lucide-react';
import { projectHighlights } from '../data/mock';

const iconMap = {
  MapPin,
  Building2,
  Car,
  Users,
  Heart,
  Accessibility
};

const OverviewSection = () => {
  return (
    <section id="overview" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-emerald-600 font-semibold text-sm tracking-wider uppercase mb-4 block">
            Project Overview
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            A Vision for Community Growth
          </h2>
          <p className="text-slate-600 text-lg max-w-3xl mx-auto leading-relaxed">
            Stadium Plaza Center is designed to become a cornerstone of Georgetown's commercial landscape,
            offering modern amenities, strategic positioning, and a tenant mix that serves diverse community needs.
          </p>
        </div>

        {/* Highlights Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projectHighlights.map((highlight, index) => {
            const IconComponent = iconMap[highlight.icon];
            return (
              <div
                key={highlight.id}
                className="group bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-100 hover:border-emerald-200"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="w-14 h-14 bg-emerald-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-emerald-100 transition-colors">
                  <IconComponent className="text-emerald-600" size={28} />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  {highlight.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {highlight.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-emerald-50 rounded-full px-6 py-3">
            <span className="w-3 h-3 bg-emerald-500 rounded-full animate-pulse" />
            <span className="text-emerald-700 font-medium">
              Pre-leasing now available for qualified tenants
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OverviewSection;
